import { Controller } from "@hotwired/stimulus"

export default class ClipboardController extends Controller {
  static targets = ["source", "button"]
  static values = { copied: String }

  declare sourceTarget: HTMLInputElement
  declare buttonTarget: HTMLButtonElement
  declare copiedValue: string

  copy(): void {
    navigator.clipboard.writeText(this.sourceTarget.value)
    const originalText = this.buttonTarget.textContent
    this.buttonTarget.textContent = this.copiedValue || "Copied!"
    setTimeout(() => {
      this.buttonTarget.textContent = originalText
    }, 2000)
  }
}
